import { environment } from '../../../../environments/environment';
import { GlobalService } from './../../../core/services/global/global.service';
import { HttpService } from './../../../core/http/http.service';
import { Injectable } from '@angular/core';
import { IResponseMonetaryFee as IResponsePockets } from './../../../core/models/monetary-fee/iresponse-monetary-fee';
import { IWorkerInformation } from './../../../core/models/worker/iworker-information';
import { IWresponseData } from './../../../core/models/worker/iwresponse-data';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { WresponseData, DescargaInfoTrab } from 'src/app/core/models/worker/wresponse-data';
import { GeneralResponse } from 'src/app/core/models/general-response/general-response';
import { LocalStorageService } from 'src/app/core/services/local-storage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class WorkerInformationService {

  constructor(private _http: HttpService){ }

  searchDataUser(data: IWorkerInformation): Observable<IWresponseData> {

    return this._http.post<IWresponseData>(
      environment.ORQUESTADOR.API_URL,
      '/requestServices',
      data
    ).pipe(
      map((response) => {
        return response;
      })
    );
  }

  checkMonetaryFee(data: {}): Observable<IResponsePockets> {

    return this._http.post<IResponsePockets>(
      environment.CUOTA_MONETARIA.EMPRESAS_API,
      '/consulta',
      data
    ).pipe(
      map((response) => {
        return response;
      })
    );

  }

  getInfoTrab(wResponseData: WresponseData): Observable<DescargaInfoTrab> {
    return this._http.post<DescargaInfoTrab>(
      environment.AFILIACION.INFORMACION_TRABABAJADOR_API,
      '/downloadInformation',
      wResponseData
    ).pipe(
      map((response) => {
        return response;
      })
    );

  }

  getMonetaryFee(tams: string, typeDoc: string, numDoc: string): Observable<Array<IResponsePockets>> {
    const params = {
      tams, typeDoc, numDoc
    };
    return this._http.get<GeneralResponse<Array<IResponsePockets>>>(
      environment.CUOTA_MONETARIA.EMPRESAS_CUOTA_SUBSIDIO_FAMILIAR_API,
      '/abono',
      params
    ).pipe(map((response => response.body)));

  }
  getCertificateMonetaryState(typeDoc: string, numDoc: string, format: string, from: string, to: string): Observable<any> {
    const params = {
      "typeDoc":typeDoc,"numDoc": numDoc, "from": from, "to": to
    };
    return this._http.get<GeneralResponse<any>>(
      environment.CUOTA_MONETARIA.PERSONAS_ESTADO_CUENTA_API,
      `/${format}`,
      params
    ).pipe(map((response => response.body)));
  }

  getSChool(tams: string, typeDoc: string, numDoc: string): Observable<Array<IResponsePockets>> {
    const params = {
      tams, typeDoc, numDoc
    };
    return this._http.get<GeneralResponse<Array<IResponsePockets>>>(
      environment.SUBSIDIO_ESCOLAR.API_URL,
      '/abono',
      params
    ).pipe(map((response => response.body)));

  }

  getMovePocketsDebit(tams: string, typeDoc: string, numDoc: string): Observable<Array<IResponsePockets>> {
    const params = {
      tams, typeDoc, numDoc
    };
    return this._http.get<GeneralResponse<Array<IResponsePockets>>>(
      environment.SUBSIDIO_ESCOLAR.API_URL,
      '/movimientos',
      params
    ).pipe(map((response => response.body)));

  }

  retreatWorker(typeDoc: string,numDoc: string): Observable<Array<any>>{
    const params = {
      typeDoc,numDoc
    };
    return this._http.get<GeneralResponse<Array<any>>>(
      environment.DESAFILIACION_INDIVIDUAL_API.PREFIJO_URL,
      '/individual',
      params
    ).pipe(map((response => response.body)));
  }
}
